import React, { PureComponent, Fragment } from 'react'
import { Grid, Tabs, Tab, InputLabel, MenuItem } from '@material-ui/core'

import { connect } from 'react-redux'
import ContainerWithTitleWrapper from '../../HOC/ContainerWithTitle'
import FeeItemContainer from '../../../components/FeeMinimums/FeeItemContainer'
import ShopSettingsWithUpdate from '../../../components/layout/ShopSettingsWithUpdate'
import { EditableInput, EditableSelect } from '../../../components/common/EditableComponents'
import EditActionComponent from '../../../components/common/EditActionComponent'
import { openErrorMessage } from '../../../actions/message'
import { hasAccess } from '../../../utils/api'
import _ from 'lodash'
import { Appcues } from '../../../utils/constants'
import { getFeeList, addUpdateFee } from '../../../actions/shop'
import WarningFeeMinimums from './WarningFeeMinimums'

class FeeMinimums extends PureComponent {
  constructor(props) {
    super(props)
    this.state = {
      activeTab: 'CART_MINIMUM',
      feeType: 'CART_SUB_TOTAL',
      minimumsType: 'SIMPLE',
      cartMinimumsType: 'Subtotal',
      minimum: 0,
      editMode: false,
      warningFeeMinimusCheked: true,
    }
  }
  hideWarningFeeMinimus() {
    this.setState({
      warningFeeMinimusCheked: false,
    })
    console.log('hide')
  }
  showWarningFeeMinimus() {
    this.setState({
      warningFeeMinimusCheked: true,
    })
    console.log('show')
  }

  componentDidMount() {
    this.resetState()
    this.getCashlessAtmFeeList()
  }

  getCashlessAtmFeeList = () => {
    this.props.dispatch(getFeeList('CashlessAtm'))
  }

  resetState() {
    const { shop } = this.props
    const { allowDelivery } = shop || {}
    const feeType =
      (shop && shop.deliveryFees && shop.deliveryFees.length && shop.deliveryFees[0].feeType) ||
      'CART_SUB_TOTAL'
    const minimumsType = (shop && shop.cartMinimums && shop.cartMinimums.minimumsType) || 'SIMPLE'
    const cartMinimumsType =
      (shop && shop.onlineStoreInfo && shop.onlineStoreInfo.cartMinType) || 'Subtotal'
    const minimum =
      (shop &&
        shop.cartMinimums &&
        shop.cartMinimums.cartMinimumDetails &&
        shop.cartMinimums.cartMinimumDetails[0] &&
        shop.cartMinimums.cartMinimumDetails[0].minimum) ||
      0
    const activeTab = allowDelivery ? 'DELIVERY' : 'CART_MINIMUM'
    this.setState({
      activeTab,
      feeType,
      minimumsType,
      cartMinimumsType,
      minimum,
    })
  }

  changeActiveTab = (event, value) => {
    this.resetState()
    this.setState({
      activeTab: value,
      editMode: false,
    })
  }

  onSave = (key) => (feeList) => {
    Appcues.track('Fee Minimum Saved')
    const { shop = {} } = this.props
    const { activeTab, feeType, minimumsType, cartMinimumsType, minimum } = this.state
    let onlineStoreInfo = { ...shop.onlineStoreInfo }

    const valid = this.validate(feeList)

    if (valid) {
      if (activeTab === 'DELIVERY') {
        let updatedFeeList =
          (feeList &&
            feeList.length &&
            feeList.map((fee) => {
              return { ...fee, feeType }
            })) ||
          []
        return this.props.updateShop({ ...shop, [key]: updatedFeeList })
      }
      if (activeTab === 'CART_MINIMUM') {
        let updatedCartMinimums = { ...shop.cartMinimums }

        if (minimumsType === 'SIMPLE') {
          if (isNaN(minimum) || minimum < 0) {
            return this.props.dispatch(openErrorMessage('Please enter correct cart minimum'))
          }
          onlineStoreInfo = { ...onlineStoreInfo, cartMinType: cartMinimumsType }
          updatedCartMinimums = {
            ...shop.cartMinimums,
            minimumsType,
            cartMinimumDetails: [{ minimum }],
          }
        } else {
          onlineStoreInfo = { ...onlineStoreInfo, cartMinType: cartMinimumsType }
          updatedCartMinimums = { ...shop.cartMinimums, minimumsType, cartMinimumDetails: feeList }
        }

        return this.props.updateShop({
          ...shop,
          cartMinimums: updatedCartMinimums,
          onlineStoreInfo,
        })
      }
      if (activeTab === 'CASHLESS_ATM') {
        return this.props
          .dispatch(addUpdateFee('CashlessAtm', feeList))
          .then((res) => {
            this.getCashlessAtmFeeList()
          })
          .catch((err) => {
            return this.props.dispatch(openErrorMessage(err))
          })
      } else if (activeTab === 'ACH') {
        let updatedFeeList =
          (feeList &&
            feeList.length &&
            feeList.map((fee) => {
              return { ...fee, feeType: 'ACH' }
            })) ||
          []
        return this.props.updateShop({ ...shop, [key]: updatedFeeList })
      } else {
        return this.props.updateShop({ ...shop, [key]: feeList })
      }
    } else {
      return new Promise((resolve, reject) => {
        reject('error')
      })
    }
  }

  handleChange = (event) => {
    this.setState({
      [event.target.name]: event.target.value,
    })
  }

  onCancel = () => {
    this.resetState()
    this.setState({
      editMode: false,
    })
  }

  saveConfig = () => {
    const { shop = {} } = this.props
    const { activeTab = '', minimumsType, cartMinimumsType, minimum, feeType = '' } = this.state
    Appcues.track('Fee Minimums Saved')
    if (activeTab === 'DELIVERY') {
      const { deliveryFees = [] } = shop
      let updatedFeeList =
        (deliveryFees &&
          deliveryFees.length &&
          deliveryFees.map((fee) => {
            return { ...fee, feeType }
          })) ||
        []
      this.props.updateShop({ ...shop, deliveryFees: updatedFeeList }).then((res) => {
        this.setState({
          editMode: false,
        })
      })
    }
    if (activeTab === 'CART_MINIMUM') {
      let updatedCartMinimums = { ...shop.cartMinimums }
      let onlineStoreInfo = { ...shop.onlineStoreInfo }
      if (minimumsType === 'SIMPLE') {
        if (isNaN(minimum) || minimum < 0) {
          return this.props.dispatch(openErrorMessage('Please enter correct cart minimum'))
        }
        onlineStoreInfo = { ...onlineStoreInfo, cartMinType: cartMinimumsType }
        updatedCartMinimums = {
          ...updatedCartMinimums,
          minimumsType,
          cartMinimumDetails: [{ minimum }],
        }
      } else {
        onlineStoreInfo = { ...onlineStoreInfo, cartMinType: cartMinimumsType }
        updatedCartMinimums = { ...shop.cartMinimums, minimumsType }
      }

      this.props
        .updateShop({ ...shop, cartMinimums: updatedCartMinimums, onlineStoreInfo })
        .then((res) => {
          this.setState({
            editMode: false,
          })
        })
    }
  }

  enableEdit = () => {
    this.setState({
      editMode: true,
    })
  }
  validate(feeList) {
    let dup = false
    let errorMsg = ''
    const { activeTab = '', feeType, minimumsType } = this.state
    const config = activeTab === 'DELIVERY' ? feeType : minimumsType
    let uniqueThresholds = []
    let uniqueZips = {}

    for (let i = 0; i < feeList.length; ++i) {
      if (activeTab !== 'CART_MINIMUM') {
        if (isNaN(feeList[i].fee) || feeList[i].fee < 0) {
          this.props.dispatch(
            openErrorMessage('Please enter correct fee amount. Fee cannot be 0 or lower'),
          )
          return false
        }
        if (feeList[i].type === 'Percentage' && feeList[i].fee > 100) {
          this.props.dispatch(openErrorMessage('Fee cannot be more than 100%'))
          return false
        }
        if (
          config === 'CART_SUB_TOTAL' &&
          (isNaN(feeList[i].subTotalThreshold) || feeList[i].subTotalThreshold < 0)
        ) {
          this.props.dispatch(openErrorMessage('Please enter correct subtotal minimum'))
          return false
        }
        if (activeTab === 'CREDIT_CARD') {
          if (isNaN(feeList[i].subTotalThreshold) || feeList[i].subTotalThreshold < 0) {
            this.props.dispatch(openErrorMessage('Please enter correct subtotal minimum'))
            return false
          }
        }
      } else {
        if (isNaN(feeList[i].minimum) || feeList[i].minimum < 0) {
          this.props.dispatch(openErrorMessage('Please enter correct fee amount'))
          return false
        }
        if (feeList[i].type === 'Percentage' && feeList[i].minimum > 100) {
          this.props.dispatch(openErrorMessage('Fee cannot be more than 100%'))
          return false
        }
      }

      /* if(config == 'DISTANCE' && (isNaN(feeList[i].distance) || feeList[i].distance < 0) ) {
				this.props.dispatch(openErrorMessage('Please enter correct distance'));
				return false;
			} */

        const subTotal = parseFloat(feeList[i].subTotalThreshold).toFixed(2)
        if (uniqueThresholds.includes(subTotal)) {
          dup = true
          errorMsg = 'Minimum amount must be unique'
        } else {
          uniqueThresholds = [...uniqueThresholds, subTotal]
        }
        if (config.toLowerCase() === 'zip_code') {
          for (let z = 0; z < ((feeList[i].zipCodes && feeList[i].zipCodes.length) || 0); z++) {
            let zipCode = feeList[i].zipCodes[z]
            if (uniqueZips[zipCode]) {
              dup = true
              errorMsg = 'Please enter unique zipcodes'
              break
            }
            uniqueZips[zipCode] = zipCode
          }
        }
        // check dup
        if (dup) {
          break
        }
    }

    if (dup) {
      this.props.dispatch(openErrorMessage(errorMsg))
      return false
    } else {
      return true
    }
  }

  render() {
    const { shop = {} } = this.props
    const { allowDelivery } = shop
    const { lastModified, CashlessAtmfeeList = [] } = this.props.shopReducer
    const {
      activeTab,
      feeType = '',
      minimumsType = '',
      cartMinimumsType = '',
      minimum = 0,
      editMode = false,
    } = this.state
    let titles = []

    switch (activeTab) {
      case 'CART_MINIMUM':
        titles = [
          'Cart Amount',
          minimumsType === 'SIMPLE' ? 'Subtotal Minimum' : 'Zipcodes (comma delimited)',
          'Enabled',
        ]
        break
      case 'DELIVERY':
        titles = [
          'Type',
          'Fee Amount',
          feeType === 'CART_SUB_TOTAL' ? 'Subtotal Minimum' : 'Zipcodes (comma delimited)',
          'Enabled',
        ]
        break
      case 'ACH':
        titles = ['Type', 'Fee Name', 'Fee Amount', 'Subtotal Minimum', 'Enabled']
        break
      case 'BLAZEPAY':
        titles = ['Type', 'Fee Name', 'Fee Amount', 'Enabled']
        break
      case 'CREDIT_CARD':
        titles = ['Type', 'Fee Name', 'Fee Amount', 'Subtotal Minimum', 'Enabled']
        break
      case 'CASHLESS_ATM':
        titles = ['Type', 'Fee Name', 'Fee Amount', 'Subtotal Minimum', 'Enabled']
        break
      case 'STRONGHOLD':
        titles = ['Type', 'Fee Name', 'Fee Amount', 'Enabled']
        break

      default:
        break
    }

    return (
      <div>
        <Grid container>
          {this.state.warningFeeMinimusCheked ? (
            <Grid item container xs={12} justify="center">
              <WarningFeeMinimums />
            </Grid>
          ) : null}
        </Grid>

        <Grid container>
          <Grid item container xs={12} sm={12} md={12} lg={12} justify="center">
            <Tabs
              value={this.state.activeTab}
              indicatorColor="primary"
              textColor="primary"
              onChange={this.changeActiveTab}
              centered
            >
              <Tab label="CART MINIMUM" value="CART_MINIMUM" />
              {allowDelivery ? <Tab label="DELIVERY" value="DELIVERY" /> : null}
              <Tab label="ACH" value="ACH" />
              <Tab label="BLAZEPAY" value="BLAZEPAY" />
              <Tab data-cy="tab-cashless-atm" label="CASHLESS ATM" value="CASHLESS_ATM" />
              <Tab data-cy="tab-credit-card" label="CREDIT CARD" value="CREDIT_CARD" />
              <Tab label="STRONGHOLD" value="STRONGHOLD" />
            </Tabs>
          </Grid>
          {hasAccess() &&
          activeTab !== 'CREDIT_CARD' &&
          activeTab !== 'CASHLESS_ATM' &&
          activeTab !== 'BLAZEPAY' &&
          activeTab !== 'ACH' &&
          activeTab !== 'STRONGHOLD' ? (
            <Grid className="addButton" item xs={12} sm={12} md={12} lg={12}>
              <EditActionComponent
                className="pull-right"
                onSave={this.saveConfig}
                onCancel={this.onCancel}
                onEdit={this.enableEdit}
                editMode={editMode}
              />
            </Grid>
          ) : null}
          {activeTab === 'CART_MINIMUM' ? (
            <Fragment>
              <Grid
                container
                className="margin-top-medium"
                justify="center"
                onClick={this.hideWarningFeeMinimus()}
              >
                <Grid item xs={12} sm={4} md={4} lg={2} className="text-align">
                  <InputLabel>Configuration</InputLabel>
                </Grid>
                <Grid item xs={12} sm={4} md={4} lg={3} className="select-margin">
                  <EditableSelect
                    valueToRender={_.startCase(
                      _.toLower((minimumsType && minimumsType.replace(/_/g, ' ')) || ''),
                    )}
                    value={minimumsType}
                    onChange={(event) => this.handleChange(event)}
                    fullWidth={true}
                    name="minimumsType"
                    editMode={editMode}
                  >
                    <MenuItem value="SIMPLE">Simple</MenuItem>
                    <MenuItem value="ZIP_CODE">By Zipcode</MenuItem>
                  </EditableSelect>
                </Grid>
                <Grid container className="margin-top-medium" justify="center">
                  <Grid item xs={12} sm={4} md={4} lg={2} className="text-align">
                    <InputLabel>Cart Minimum Type</InputLabel>
                  </Grid>
                  <Grid item xs={12} sm={4} md={4} lg={3} className="select-margin">
                    <EditableSelect
                      valueToRender={_.startCase(cartMinimumsType || '')}
                      value={cartMinimumsType}
                      onChange={(event) => this.handleChange(event)}
                      fullWidth={true}
                      name="cartMinimumsType"
                      editMode={editMode}
                    >
                      <MenuItem value="Subtotal">Subtotal only</MenuItem>
                      <MenuItem value="SubtotalWithDiscount">Subtotal With Discounts</MenuItem>
                    </EditableSelect>
                  </Grid>
                </Grid>
                {minimumsType === 'SIMPLE' ? (
                  <Grid container className="margin-top-medium" justify="center">
                    <Grid item xs={12} sm={4} md={4} lg={2} className="text-align">
                      <InputLabel>Cart Minimum</InputLabel>
                    </Grid>
                    <Grid item xs={12} sm={4} md={4} lg={3} className="select-margin">
                      <EditableInput
                        name="minimum"
                        type="number"
                        valueToRender={minimum || 0}
                        value={minimum}
                        editMode={editMode}
                        onChange={this.handleChange}
                        min={0}
                      />
                    </Grid>
                  </Grid>
                ) : null}
              </Grid>
              {minimumsType !== 'SIMPLE' ? (
                <FeeItemContainer
                  titles={titles}
                  feeList={(shop.cartMinimums && shop.cartMinimums.cartMinimumDetails) || []}
                  onSave={this.onSave('cartMinimums')}
                  lastModified={lastModified}
                  config={minimumsType.toUpperCase()}
                  cartMinimum={true}
                  activeTab={activeTab}
                />
              ) : null}
            </Fragment>
          ) : null}

          {activeTab === 'ACH' ? (
            <FeeItemContainer
              titles={titles}
              feeList={shop.achFeeList || []}
              onSave={this.onSave('achFeeList')}
              lastModified={lastModified}
              showFeeType={true}
              activeTab={activeTab}
              onClick={this.showWarningFeeMinimus()}
            />
          ) : null}
          {activeTab === 'BLAZEPAY' ? (
            <FeeItemContainer
              titles={titles}
              feeList={shop.blazePayFeeList || []}
              onSave={this.onSave('blazePayFeeList')}
              lastModified={lastModified}
              showFeeType={true}
              activeTab={activeTab}
              onClick={this.showWarningFeeMinimus()}
              isBLAZEPAY={true}
            />
          ) : null}
          {activeTab === 'CASHLESS_ATM' ? (
            <FeeItemContainer
              titles={titles}
              feeList={(CashlessAtmfeeList && CashlessAtmfeeList.fee) || []}
              onSave={this.onSave('cashLessAtm')}
              lastModified={lastModified}
              showFeeType={true}
              onClick={this.showWarningFeeMinimus()}
              activeTab={activeTab}
            />
          ) : null}
          {activeTab === 'CREDIT_CARD' ? (
            <FeeItemContainer
              titles={titles}
              feeList={shop.creditCardFeeList || []}
              onSave={this.onSave('creditCardFeeList')}
              lastModified={lastModified}
              showFeeType={true}
              onClick={this.showWarningFeeMinimus()}
              activeTab={activeTab}
            />
          ) : null}
          {activeTab === 'STRONGHOLD' ? (
            <FeeItemContainer
              titles={titles}
              feeList={shop.strongholdFeeList || []}
              onSave={this.onSave('strongholdFeeList')}
              lastModified={lastModified}
              showFeeType={true}
              activeTab={activeTab}
              onClick={this.showWarningFeeMinimus()}
              isSTRONGHOLD={true}
            />
          ) : null}

          {activeTab === 'DELIVERY' ? (
            <Fragment>
              <Grid
                container
                className="margin-top-medium"
                justify="center"
                onClick={this.hideWarningFeeMinimus()}
              >
                <Grid item xs={12} sm={3} md={3} lg={2} className="label-margin">
                  <InputLabel>Configuration</InputLabel>
                </Grid>
                <Grid item xs={12} sm={4} md={4} lg={3} className="select-margin">
                  <EditableSelect
                    editMode={editMode}
                    valueToRender={feeType == 'CART_SUB_TOTAL' ? 'Cart Subtotal' : 'Zip Code'}
                    value={feeType}
                    onChange={(event) => this.handleChange(event)}
                    fullWidth={true}
                    name="feeType"
                  >
                    <MenuItem value="CART_SUB_TOTAL">By Cart Subtotal</MenuItem>
                    <MenuItem value="ZIP_Code">By Zipcode</MenuItem>
                  </EditableSelect>
                </Grid>
              </Grid>
              <FeeItemContainer
                titles={titles}
                feeList={shop.deliveryFees || []}
                onSave={this.onSave('deliveryFees')}
                lastModified={lastModified}
                config={feeType.toUpperCase()}
                showFeeType={true}
                activeTab={activeTab}
              />
            </Fragment>
          ) : null}
        </Grid>
      </div>
    )
  }
}

const FeeMinimumsWithTitle = ContainerWithTitleWrapper(FeeMinimums, 'Fee Minimums')

export default connect(({ dispatch, shopReducer }) => ({
  dispatch,
  shopReducer,
}))(ShopSettingsWithUpdate(FeeMinimumsWithTitle))



// WEBPACK FOOTER //
// ./src/containers/Settings/Shop/FeeMinimums.js